import classNames from 'classnames'
import React, { FC } from 'react'

import s from './WixMobilePage.scss'

interface WixMobilePageProps {
  skin?: 'new-funnel' | 'standard'
}

export const WixMobilePage: FC<WixMobilePageProps> = ({ children, skin = 'standard' }) => {
  return (
    <div
      className={classNames({
        [s.page]: skin === 'standard',
        [s.pageNF]: skin === 'new-funnel',
      })}
    >
      {children}
    </div>
  )
}
